<div style="padding:0px;height: 100%;overflow-y: hidden;" >
    <iframe [src]="this.url" width="100%" height="100%" style="border: 0px;"></iframe>
</div>
